import { ref, onMounted } from '@vue/composition-api'
import { cpRequestUseCase } from '../../usecases'
import { useErrors, useRouter } from '../../hooks';
import {cpRequestUtils} from '../../utils';

const useSpots = (campaignId, isPartner) => {

    const spots = ref([])
    const selectedSpot = ref({})
    const scheduler = ref([])

    const errorHandler = useErrors();
    const {route} = useRouter();
    const partner = isPartner ? '-partner' : '';
    
    onMounted(() => {
        if(campaignId){
            initSpots(campaignId)
        }
    })

    const initSpots = (id = campaignId) => {

        errorHandler.setError('no-update-date'+partner, false)

        selectedSpot.value = null;

        if(!isPartner){
            spots.value = []
        }
        
        cpRequestUseCase.getUpdatesByCampaignId(id)
        .then( data => {
            
            scheduler.value = data

            if (!data.length) {
                errorHandler.setError('no-update-date'+partner, true)
            }


            const schedule = cpRequestUseCase.preselectDate(0, scheduler.value)

            if(schedule) {
                setSpots(schedule);
            }
        })
        .catch(err => {
            console.log(err);
        })
    }

    const setSpots = (schedule, campId) => {
        errorHandler.setError('pick-date'+partner, false)
        errorHandler.setError('already-requested'+partner, false)

        if (cpRequestUtils.isAlreadyRequestedDate(schedule.spots, !isPartner ? route.value.query.project_id : campId)) {
            errorHandler.setError('already-requested'+partner, true)
        }

        spots.value = cpRequestUtils.formSpots(schedule.spots);
        selectedSpot.value = cpRequestUtils.formSelectedSpot(selectedSpot.value, schedule);

        errorHandler.setError('all-spots-are-taken'+partner,  spots.value.every(spot => spot.busy));
    }

    const selectSpot = (index, busy) => {
        if (busy) return
        errorHandler.setError('pick-spot'+partner, false)
        selectedSpot.value.index = index
    };


    return {
        spots,
        selectedSpot,
        scheduler,
        selectSpot,
        initSpots,
        setSpots
    }
}

export default useSpots